// extracted by mini-css-extract-plugin
export default {"PageLinkContainer":"PageLink_PageLinkContainer__Vldbi","PageNumber":"PageLink_PageNumber__XKbi-","CurrentPage":"PageLink_CurrentPage__40Oj+"};